/* Functions here is to format data display in UI,
 * because "filter" will not support in Vue 3.
 */
import moment from 'moment'
import { SHARED, DATE } from '@/constants'
import i18n from '@/i18n'

export const paginateTableIndex = (value, pageNumber, pageSize = SHARED.DEFAULT_PAGE_SIZE) => {
  let result = ''

  if (typeof value === 'number') {
    result = value + 1 + (pageNumber - 1) * pageSize
  }

  return result < 10 ? '0' + result : result
}

export const getCurrencyFormat = (value, decimalPlaces = 2) => {
  let desc = ''

  if (value != undefined && value != null) {
    desc = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: decimalPlaces
    }).format(value)
  }

  return desc.replace('$', '')
}

export const getDateFormat = (value, numeric=false) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    if(numeric) {
      let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
      desc = moment(dateTimeGMT8).format('YYYY-MM-DD')
    } else {
      let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
      desc = moment(dateTimeGMT8).format(DATE.SHORT)
    }
  }

  return desc
}

export const getTimeFormat = (value) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
    desc = moment(dateTimeGMT8).format(DATE.TIME)
  }

  return desc
}

export const getDateTimeFormat = (value, numeric=false, timeShort = false) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    if (numeric) {
      // compatible value in locale format: 'Wed Nov 12 2025 19:30:00 GMT+0800 (Malaysia Time)'
      if(timeShort) {
        desc = new Date(value).toISOString().replace('T', ' ').substr(0, 16); // "YYYY-MM-DD HH:mm"
      } else {
        desc = new Date(value).toISOString().replace('T', ' ').split('.')[0]; // "YYYY-MM-DD HH:mm:ss"
      }
    } else {
      //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
      //moment will auto convert it into client timezone
      let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
      desc = moment(dateTimeGMT8).format(DATE.LONG)
    }
  }

  return desc
}

export const getActivationStatus = (value) => {
  let desc = ''

  if (typeof value === 'number') {
    desc = i18n.t(`enumActivationStatus[0].${value}`)
  } else if (typeof value === 'boolean') {
    desc = i18n.t(`enumActivationStatus[1].${value}`)
  } else if (typeof value === 'string' && value != '') {
    desc = i18n.t(`enumActivationStatus[2].${value.toLowerCase()}`)
  }

  return desc
}

export const getSmartNumberFormat = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined || value === '') return ''
  const fixed = Number(value).toFixed(decimalPlaces)
  return parseFloat(fixed).toString()
}

export const getDateTimeNumeric = ({value, timeIsShort=false}) => {
  if(!value) return '';
  const val = typeof value === 'string' ? value : value.toString();

  // sample ISO value: '2025-11-11T09:00:00.000000Z', '2025-11-11T16:00:00+08:00'
  const isoMatch = val.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})/);
  if(isoMatch) {
    const [date, rest] = value.split('T');
    const time = rest.split(/[.+-]/)[0];
    return timeIsShort
      ? `${date} ${time.slice(0, 5)}` // "YYYY-MM-DD HH:mm"
      : `${date} ${time}`;            // "YYYY-MM-DD HH:mm:ss"
  }
}